import * as types from "./mutations-types";
import moment from "moment";

export default {
  [types.SET_ALL_PAYMENTS](state, payload) {
    const { data, page } = payload;

    const getDate = (item) => {
        const created_at = item?.reward_created_at || item?.closure?.created_at;
        return moment(created_at);
    };

    if (Array.isArray(data)) {

        state.all_payments[page] = data.sort((a, b) => {
          const dateA = getDate(a);
          const dateB = getDate(b);

          return dateB.valueOf() - dateA.valueOf(); // Ordem decrescente (mais recente primeiro)
      })

    } 
    
    if ( !Array.isArray(data) ) {
      // Para dados únicos, adiciona ao array e ordena novamente
      const allPayments = [...state.all_payments, data];

      state.all_payments = allPayments.sort((a, b) => {
          const dateA = getDate(a);
          const dateB = getDate(b);
          
          return dateB.valueOf() - dateA.valueOf();
      });
    }
  },

  [types.CLEAR_ALL_PAYMENTS](state) {
    state.all_payments = []
  },

  [types.SET_LAST_PAGE_OF_PAGINATION](state, payload) {
    state.last_page_of_pagination = payload
  },

  [types.SET_CURRENT_PAGE_OF_PAGINATION](state, payload) {
    state.current_page_of_pagination = payload
  },

  [types.SET_CURRENT_KEY_REFRESH_COMPONENTS](state, payload) {
    state.current_key_refresh_components = payload
  },

  [types.SET_ALL_RESCUES_OPEN](state, payload) {
    state.all_rescues_open = payload
  },

  [types.SET_PAGES_ALREADY_LOADED](state, payload) {
    state.pages_already_loaded.push(payload)
  },

  [types.SET_PAGES_ALREADY_LOADED_CREDITS_UNDER_REVIEW](state, payload) {
    state.credits_under_review.pages_already_loaded.push(payload)
  },

  [types.CLEAR_PAGINATION_ALREADY_LOADED](state) {
    state.pages_already_loaded = []
  },

  [types.SET_IS_RELOADING_COMPONENTS](state, payload) {
    state.is_reloading_components = payload
  },

  [types.SET_AVAILABLE_FOR_REDEMPTION](state, payload) {
    const { available_for_redemption } = state;

    if (!available_for_redemption) {
      return state.available_for_redemption = payload;
    }

    const currentPoints = available_for_redemption.points;
    const sumPoints = currentPoints.concat(payload.points);

    state.available_for_redemption = {
      ...payload,
      points: sumPoints
    }
  },

  [types.SET_CREDITS_UNDER_REVIEW](state, payload) {
    const { credits_under_review } = state;

    if (!credits_under_review.data) {
      return state.credits_under_review.data = payload;
    }

    /* Se já tiver pontos, soma com os novos pontos que vieram do serviço */
    const currentPoints = credits_under_review.data.points;
    const sumPoints = currentPoints.concat(payload.points);

    state.credits_under_review.data = {
      ...payload,
      points: sumPoints
    }
  },

  [types.SET_CREDITS_RESCUED_DETAILS](state, data) {
    state.credits_rescued_details = data
  },

  [types.SET_TYPE_OF_SERVICES_ALLOWED](state, payload) {
    state.type_of_services_allowed = payload
  },

  [types.SET_MONEY_VISIBILITY](state, payload) {
    state.is_money_visible = payload
  },
}